import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useApp } from '../../../contexts/AppContext';
import config from '../../../config';
import news1 from './news1.webp';
import news2 from './news2.webp';
import news3 from './news3.webp';

const Page = styled.div`
  padding: 50px 0px 20px;
  @media ${config.layout.wide} {
    padding: 64px 0 50px;
  }
`;

const PageFeatureTitle = styled.div`
  position: relative;

  h2 {
    font-size: 50px;
    font-weight: 300;
    font-size: 50px;
    line-height: 1;
    text-align: left;
    padding-bottom: 50px;

    border-bottom: 1px solid #d9d9d9;

    @media ${config.layout.wide} {
      font-size: 70px;
      padding-bottom: 60px;
    }
  }
`;

const PageContent = styled.div``;

const NewsItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
`;

const NewsItem = styled.a`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
  text-decoration: none;
  color: inherit;
  padding: 40px 0;
  border-bottom: 1px solid #d9d9d9;

  @media ${config.layout.wide} {
    flex-direction: row;
    gap: 30px;
    position: relative;
  }
`;

const NewsItemMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  p {
    margin: 0;
    font-weight: normal;
    font-size: 14px;
    line-height: 1;
    text-align: left;
    color: #4a4a4a;

    @media ${config.layout.wide} {
      font-size: 16px;
    }
  }

  h3 {
    margin: 0;
    position: relative;
    padding-left: 22px;
    font-weight: normal;
    font-size: 16px;
    line-height: 26px;
    text-align: left;
    color: #4a4a4a;

    @media ${config.layout.wide} {
      font-size: 20px;
      line-height: 26px;
    }

    &::before {
      content: '';
      position: absolute;
      left: 3px;
      top: 9px;
      transform: rotate(-45deg);
      width: 8px;
      height: 8px;
      border-bottom: 1px solid #4a4a4a;
      border-right: 1px solid #4a4a4a;
    }
  }
`;

const NewsItemImage = styled.div`
  width: 100%;
  aspect-ratio: 400 / 210;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
  flex: 0 0 auto;

  @media ${config.layout.wide} {
    width: 43%;
  }
`;

export default function NewsPage() {
  const app = useApp();
  const { t } = useTranslation();

  useEffect(() => {
    app.setTitle(t('news.documentTitle'));
  }, []);

  return (
    <Page>
      <PageFeatureTitle>
        <h2>{t('news.titleHeading')}</h2>
      </PageFeatureTitle>
      <PageContent>
        <NewsItems>
          <NewsItem
            href={t('news.newsSample1Url')}
            rel="noopener noreferrer"
            target="_blank"
          >
            <NewsItemImage style={{ backgroundImage: `url(${news1})` }} />
            <NewsItemMeta>
              <p>{t('news.newsSample1Date')}</p>
              <h3>{t('news.newsSample1Title')}</h3>
            </NewsItemMeta>
          </NewsItem>
          <NewsItem
            href={t('news.newsSample2Url')}
            rel="noopener noreferrer"
            target="_blank"
          >
            <NewsItemImage style={{ backgroundImage: `url(${news2})` }} />
            <NewsItemMeta>
              <p>{t('news.newsSample2Date')}</p>
              <h3>{t('news.newsSample2Title')}</h3>
            </NewsItemMeta>
          </NewsItem>
          <NewsItem
            href={t('news.newsSample3Url')}
            rel="noopener noreferrer"
            target="_blank"
          >
            <NewsItemImage style={{ backgroundImage: `url(${news3})` }} />
            <NewsItemMeta>
              <p>{t('news.newsSample3Date')}</p>
              <h3>{t('news.newsSample3Title')}</h3>
            </NewsItemMeta>
          </NewsItem>
        </NewsItems>
      </PageContent>
    </Page>
  );
}
